import { useQuery } from "@tanstack/react-query";
import { fetchRecipe } from "../lib/api";

export function useRecipe(slug: string) {
  return useQuery({
    queryKey: ["recipe", slug],
    queryFn: () => fetchRecipe(slug),
    enabled: Boolean(slug),
    staleTime: 1000 * 60 * 10,
  });
}
